// extracted by mini-css-extract-plugin
export var attachment = "_lg-a";
export var emailContainer = "_lg-4";
export var emailContentPaddedContainer = "_lg-b";
export var emailHeader = "_lg-6";
export var emailIframe = "_lg-3";
export var emailInfoIcon = "_lg-9";
export var emailShortenedSummary = "_lg-e";
export var infoDropdown = "_lg-0";
export var infoRowBoundedContent = "_lg-d";
export var internal = "_lg-5";
export var merchant = "_lg-8";
export var messageInputContainer = "_lg-h";
export var normal = "_lg-7";
export var replyCard = "_lg-f";
export var subtleButton = "_lg-1";
export var subtleButtonIconContainer = "_lg-2";
export var toggleViewRepliesButton = "_lg-c";
export var wrappingText = "_lg-g";